const buildings = ({ apiClient }) => ({
  status() {
    return apiClient.get('/buildings-status?nopaginate=true')
  },

  types() {
    return apiClient.get('/buildings-types?nopaginate=true')
  },
})

export default buildings
